<template>
  <div
    v-if="!accepted"
    class="cookie-consent"
  >
    <div class="cookie-content">
      <p>
        We use essential cookies to ensure the basic functionality of the site and third-party
        cookies for analytics and personalization.
      </p>
      <div class="cookie-buttons">
        <button
          class="essential-btn"
          @click="acceptEssential"
        >
          Essential Only
        </button>
        <button
          class="details-btn"
          @click="showDetails = !showDetails"
        >
          More Info
        </button>
        <button
          class="details-btn"
          @click="rejectCookies"
        >
          Reject All
        </button>
        <button
          class="accept-btn"
          @click="acceptAll"
        >
          Accept All
        </button>
      </div>
    </div>
    <div
      v-if="showDetails"
      class="cookie-details"
    >
      <h4>Cookie Details:</h4>
      <ul>
        <li><strong>Essential:</strong> Authentication, session management</li>
        <li><strong>Analytics:</strong> Site usage statistics (Google Analytics)</li>
        <li><strong>Personalization:</strong> Your preferences and settings</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';

  const accepted = ref(false);
  const showDetails = ref(false);

  onMounted(() => {
    const cookiePreference = localStorage.getItem('cookieConsent');
    // Kabul edilmiş durumları kontrol et
    accepted.value = ['all', 'essential', 'rejected'].includes(cookiePreference);
  });

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('analyticsConsent', 'true');
    accepted.value = true;
  };

  const acceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    localStorage.setItem('analyticsConsent', 'false');
    accepted.value = true;
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    accepted.value = true;
    // Çerezleri reddetme durumunda gerekli işlemleri yap
  };
</script>

<style scoped>
  .cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 1rem;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
  }

  .cookie-content {
    display: flex;
    /* max-width: 1200px; */
    margin: 0 auto;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
  }

  .cookie-buttons {
    display: flex;
    gap: 1rem;
  }

  .cookie-buttons button {
    border-radius: 4px;
    border: none;
    cursor: pointer;
  }

  .accept-btn {
    background: #4caf50;
    color: white;
  }

  .reject-btn {
    background: #f44336;
    color: white;
  }

  .details-btn {
    background: #2196f3;
    color: white;
  }

  .cookie-details {
    max-width: 1200px;
    margin: 1rem auto;
    padding: 1rem;
    background: #f5f5f5;
    border-radius: 4px;
  }
</style>
